function isAwardsMobileViewport() {
    return window.matchMedia("(max-width: 767px)").matches;
}

function shouldInitAwardsSlick(totalItems) {
    if (isAwardsMobileViewport()) {
        return totalItems > 3;
    }
    if (window.matchMedia("(max-width: 1023px)").matches) {
        return totalItems > 3;
    }
    return totalItems > 4;
}

function getAwardsSlickOptions(totalItems) {
    return {
        mobileFirst: true,
        arrows: false,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3.5,
        slidesToScroll: 1,
        adaptiveHeight: false,
        swipeToSlide: true,
        touchThreshold: 8,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: totalItems > 3,
                    infinite: totalItems > 3
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: totalItems > 4,
                    infinite: totalItems > 4
                }
            }
        ]
    };
}

function initAwardsSlick($awardsList, totalItems) {
    if (!$awardsList.length || $awardsList.hasClass("slick-initialized")) {
        return;
    }

    $awardsList.slick(getAwardsSlickOptions(totalItems));
}

function destroyAwardsSlick($awardsList) {
    if ($awardsList.hasClass("slick-initialized")) {
        $awardsList.slick("unslick");
    }
}

function syncAwardsSlick($awardsList) {
    var totalItems = $awardsList.find(".product-awards-certifications__item").length;

    if (shouldInitAwardsSlick(totalItems)) {
        initAwardsSlick($awardsList, totalItems);
        return;
    }

    destroyAwardsSlick($awardsList);
}

function initAwardsCertifications(scope, $) {
    var $scope = scope ? $(scope) : $(document);

    $scope.find(".product-awards-certifications").each(function () {
        var $section = $(this);
        var $awardsList = $section.find(".product-awards-certifications__list");

        syncAwardsSlick($awardsList);

        if ($section.data("awardsModalBound")) {
            return;
        }
        $section.data("awardsModalBound", true);

        var $modal = $section.find(".product-awards-modal");

        function closeAwardsModal() {
            $modal.removeClass("is-open").attr("aria-hidden", "true");
            $("body").removeClass("awards-modal-open");
        }

        function openAwardsModal($data) {
            if (!$data.length || !$modal.length) {
                return;
            }

            $modal.find(".product-awards-modal__icon").html($data.find(".product-awards-certifications__modal-image").html() || "");
            $modal.find(".product-awards-modal__title").html($data.find(".product-awards-certifications__modal-title").html() || "");
            $modal.find(".product-awards-modal__content").html($data.find(".product-awards-certifications__modal-description").html() || "");

            $modal.addClass("is-open").attr("aria-hidden", "false");
            $("body").addClass("awards-modal-open");
        }

        $section.on("click", ".product-icon-more", function (event) {
            event.preventDefault();
            var $data = $(this).closest(".product-awards-certifications__item").find(".product-awards-certifications__modal-data").first();
            openAwardsModal($data);
        });

        $section.on("click", ".product-awards-certifications__image-link", function (event) {
            var $item = $(this).closest(".product-awards-certifications__item");
            if (!$item.find(".product-icon-more").length) {
                return;
            }
            event.preventDefault();
            var $data = $item.find(".product-awards-certifications__modal-data").first();
            openAwardsModal($data);
        });

        $section.on("click", "[data-awards-modal-close]", function () {
            closeAwardsModal();
        });

        $section.on("click", ".product-awards-modal", function (event) {
            if (!$modal.hasClass("is-open")) {
                return;
            }

            if (!$(event.target).closest(".product-awards-modal__dialog").length) {
                closeAwardsModal();
            }
        });
    });
}

function bindAwardsEvents($) {
    var resizeTimer;

    $(document).ready(function () {
        initAwardsCertifications(document, $);
    });

    document.addEventListener("shopify:section:load", function (event) {
        initAwardsCertifications(event.target, $);
    });

    $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            $(".product-awards-certifications__list").each(function () {
                syncAwardsSlick($(this));
            });
        }, 150);
    });

    $(document).on("keydown", function (event) {
        if (event.key !== "Escape") {
            return;
        }
        $(".product-awards-modal.is-open").removeClass("is-open").attr("aria-hidden", "true");
        $("body").removeClass("awards-modal-open");
    });
}

(function bootstrapAwardsScript(retries) {
    var $ = window.jQuery;

    if (!$) {
        if (retries > 0) {
            setTimeout(function () {
                bootstrapAwardsScript(retries - 1);
            }, 50);
        }
        return;
    }

    bindAwardsEvents($);
})(40);
